import { isCountryVietnam } from '../../constants/countries';

export const routes = (countryCode) => {
  const links = [
    { text: isCountryVietnam(countryCode) ? 'Sales' : 'Bookings', value: '/bookings/' },
  ];

  if (!isCountryVietnam(countryCode)) {
    links.push({ text: 'Unit Progress', value: '/bookings/unit_progress/' });
  }
  return links;
};



// WEBPACK FOOTER //
// ./src/containers/Bookings/navigations.js